import type { TFunction } from 'i18next';

import type { FilterDef, FilterOption } from '@nucleus-commerce/admin-kit/index-table';
import { ContentBlockStatus, type ContentSection } from '@nucleus-commerce/api-client/admin';

/** Fields GET /sections sorts on; anything else is a 400. */
export const SECTION_SORTS = ['name', 'updatedAt'] as const;

const STATUSES = Object.values(ContentBlockStatus);

/**
 * The filters as the URL and the API spell them, for the route's search schema and loader. The
 * enum `options` drop unknown values the same way the page's filters do, so the prefetch and the
 * page share a query key.
 */
export const SECTION_FILTER_FIELDS = [
  { key: 'status', type: 'enum', options: STATUSES.map((value) => ({ value, label: value })) },
  { key: 'updatedAt', type: 'date-range' },
] as const;

/** Filters of the sections table, in the order the filter menu lists them. `t` is `content`. */
export function sectionFilters(t: TFunction): Array<FilterDef<ContentSection>> {
  const statuses: FilterOption[] = STATUSES.map((value) => ({
    value,
    label: t(`status.${value}`),
  }));
  return [
    { key: 'status', label: t('filters.status'), type: 'enum', pinned: true, options: statuses },
    { key: 'updatedAt', label: t('filters.updatedAt'), type: 'date-range', aliases: ['updated'] },
  ];
}
